const xvnode = (ss, cfg, gr, nd, pg, subj) => {
  const { aside, a, span } = cfg.h
  const title = subj.title || subj.label
  const label = subj.label
  const note = subj.note
  const href = subj.href

  return (
    aside('ui:', nd, [
      span(note),
      a({ href, title }, label)
    ]))
}

export default {
  type: 'uiarticleTileOneLine',
  xvnode
}
